import notfound from "assets/images/notfound.png";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const Category = (props) => {
    const cellRenderers = {
        id: () => <td>{props.category?.id}</td>,
        name: () => (
            <td className="name">
                <span>
                    <div>
                        <img
                            src={props.category.image ? props.category.image : notfound}
                            alt="category"
                        />
                    </div>
                    <div>
                        <h6>{props.category?.name}</h6>
                    </div>
                </span>
            </td>
        ),
        order: () => <td>{props.category?.order}</td>,
        type: () => <td>{props.category?.type === "supermarket" ? "سوبر ماركت" : "مطعم"}</td>,
        actions: () => (
            <td>
                <DropDownButtons
                    category={props.category}
                    edit={() => {
                        props.setSelectedCategoryValue(props.category);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedCategoryValue(props.category);
                        props.toggleDelete();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default Category;
